export var GUARANTEED = 'guaranteed';
export var MAYBE = 'maybe';
export var NONE = 'none';